// extracted by mini-css-extract-plugin
export default {"range":"lsf-range","range_align_horizontal":"lsf-range_align_horizontal","range_align_vertical":"lsf-range_align_vertical","range__body":"lsf-range__body","range__line":"lsf-range__line","range__indicator":"lsf-range__indicator","range__range-handle":"lsf-range__range-handle","range__icon":"lsf-range__icon","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385674
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  